export default "__VITE_ASSET__B59nRii6__"